import React, { ReactElement, useState } from 'react';
import {
  Alert,
  AlertIcon,
  AlertDescription,
  CloseButton,
} from '@chakra-ui/react';

export interface INotifOptions {
  type: 'success' | 'info' | 'error' | 'warning';
}
interface INotifListItem extends INotifOptions {
  message: string | ReactElement;
}

export type TAddNotif = (
  message: string | ReactElement,
  options?: INotifOptions,
) => void;
export interface IUseNotifs {
  renderNotifs: () => React.ReactNode;
  addNotif: TAddNotif;
  resetNotifs: () => void;
}

export const useNotifs = (): IUseNotifs => {
  const [list, setList] = useState<INotifListItem[]>([]);

  const renderNotifs = (): React.ReactNode => {
    return (
      list.length > 0 &&
      list.map((item, idx) => (
        <div className="bundleapp-notiflist" key={idx}>
          <Alert
            status={item.type}
            marginBottom="16px"
            className={`bundleapp-notif ${item.type}`}
          >
            <AlertIcon />
            <AlertDescription>{item.message}</AlertDescription>
            <CloseButton onClick={removeNotif(idx)} marginLeft="auto" />
          </Alert>
        </div>
      ))
    );
  };

  const removeNotif = (idx: number) => () => {
    setList([...list.slice(0, idx), ...list.slice(idx + 1)]);
  };

  const resetNotifs = () => {
    setList([]);
  };

  const addNotif = (
    message: string | ReactElement,
    options?: INotifOptions,
  ) => {
    setList((prev) => [
      {
        message,
        ...(options ? options : { type: 'success' }),
      },
      ...prev,
    ]);
  };

  return {
    addNotif,
    resetNotifs,
    renderNotifs,
  };
};
